export default {
      id: "meteor-usage",
      viewBox: "0 0 142 24",
      url: __webpack_public_path__ + "sprite.svg#meteor-usage",
      toString: function () {
        return this.url;
      }
    }